import {Component} from 'react'
import './index.css'

class CartSummary extends Component {
  getTotalPrice = () => {
    const {cartList} = this.props
    let t = 0
    cartList.forEach(each => {
      t += each.quantity * each.price
    })
    return t // Return the calculated total
  }

  render() {
    const {cartList} = this.props
    const amount = this.getTotalPrice()
    return (
      <div className="cart-summary-container">
        <h1 className="cart-summary-heading">
          Order Total: <span className="price">Rs {amount}</span>
        </h1>
        <p className="cart-summary-para">{cartList.length} items in cart</p>
        <button type="button" className="checkout-button">
          Checkout
        </button>
      </div>
    )
  }
}

export default CartSummary
